import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';
import SpinnerCircles from '../Spinner/SpinerCircles';

const WarningModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  body,
  yesButtonText,
  noButtonText,
  onCustomAction,
  customButtonText,
  children,
  loading,
  loadingCancel,
  hardClose
}) => {
   const closeBtn = (
    <button className="close" onClick={hardClose} type="button">
      &times;
    </button>
  );

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader close={!!!hardClose ? null : closeBtn}>
        <div style={{ color: 'red' }}>{title || 'Warning'}</div>
      </ModalHeader>
      <ModalBody>
        <div>{body || children}</div>
      </ModalBody>
      <ModalFooter
        className={customButtonText ? 'modalFooterEpiDelete extraButton' : 'modalFooterEpiDelete'}
      >
        {onCancel && 
          <Button outline color="secondary" onClick={onCancel} disabled={loadingCancel || loading} id="Warning-no">
            {loadingCancel ? <SpinnerCircles red /> : (noButtonText || 'No')}
          </Button>
        }
        {onConfirm && 
          <Button color="primary" onClick={onConfirm} disabled={loading || loadingCancel} id="Warning-yes">
            {loading ? <SpinnerCircles /> : (yesButtonText || 'Yes')}
          </Button>
        }
        {customButtonText && (
          <Button outline color="secondary" onClick={onCustomAction} disabled={loading || loadingCancel}>
            {customButtonText || 'No'}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default WarningModal;
